'use client';

import { mergeClasses } from 'minimal-shared/utils';

import { styled } from '@mui/material/styles';

import { RADIUS } from 'src/theme/ui-tokens';

import { flagIconClasses } from './classes';

// ----------------------------------------------------------------------

export type FlagIconProps = {
  /** ISO 3166-1 alpha-2 (대소문자 무관). 비면 아무것도 안 그린다 */
  code?: string;
  className?: string;
  sx?: any;
} & Record<string, any>;

/** 국가 코드 국기 아이콘. */
export function FlagIcon({ code, className, sx, ...other }: FlagIconProps) {
  if (!code) {
    return null;
  }

  return (
    <FlagRoot className={mergeClasses([flagIconClasses.root, className])} sx={sx} {...other}>
      <FlagImg
        loading="lazy"
        alt={code}
        src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${code?.toUpperCase()}.svg`}
        className={flagIconClasses.img}
      />
    </FlagRoot>
  );
}

// ----------------------------------------------------------------------

const FlagRoot = styled('span')(({ theme }) => ({
  width: 26,
  height: 20,
  flexShrink: 0,
  overflow: 'hidden',
  borderRadius: RADIUS.sm,
  alignItems: 'center',
  display: 'inline-flex',
  justifyContent: 'center',
  backgroundColor: theme.vars.palette.background.neutral,
}));

const FlagImg = styled('img')(() => ({
  width: '100%',
  height: '100%',
  maxWidth: 'unset',
  objectFit: 'cover',
}));
